
<template>
    <b-container>
    <b-navbar toggleable="md" type="light" variant="light" class="MenuContainer">
      <b-navbar-brand to="/">
        <!-- <img  class="logo" :src="logo" alt="Logo Gabriel Oliveira"> -->
        
      </b-navbar-brand>
  
      <!-- Links -->
      
  
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
  
      <b-collapse is-nav id="nav_collapse" class="menuItem">
        <b-navbar-nav class="ml-auto NavBar">
          <b-nav-item href="#">Home</b-nav-item>
          <b-nav-item href="#sobre">Sobre</b-nav-item>
          <b-nav-item href="#projetos">Projetos</b-nav-item>
          <b-nav-item href="#serviços">Serviços</b-nav-item>
          <!-- <a :href="CV" class="btnCV" download>
            Curriculo
            </a> -->
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
</b-container>
  </template>

<script>
export default{
    name:'navBarVue',

    data(){
    return{
    logo:'./images/logo.png',
    CV:'./assets/GabrielOliveira.pdf',
    contato:'https://api.whatsapp.com/send?phone=5512997068967',

    
}
    }
}
</script>

<style scoped>
body, html {
    margin: 0;
    padding: 0;
    width: 100%;
}

.MenuContainer {
    background-color: #4453E1 !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    color: #fff;
    width: 100vw; 
    box-sizing: border-box;
    margin: 0; 
    position: fixed;
    top: 0;
    left: 0; 
    z-index: 1000;
    border-radius: 0;
}
a{
    text-decoration: none;
    color:#fff;

}
a:hover{
    color: #f5f5f5 !important;
    text-decoration: none;
}
.menuItem{
    list-style: none;
    font-size: 1em;


}


.btn a{
    text-decoration: none;
}
.btn a:hover{
    text-decoration: none;
    color: #fff !important;
}
.btn:hover{
    border: none;
    color: #fff !important;
    background-color: #4453E1;

}

.btnCV{
    color: #4453E1 !important;
    background-color: #fff;
    border-radius: 14px;
    padding: 2%;

    transition: all 0.3s;
    -webkit-transition: width 1s;
    transition: width 1s;

    -webkit-transition: all .5s;
    -moz-transition: all .5s;
    transition: all .5s;
}
.btnCV:hover{
    background-color: #fff;
    color: #4453E1 !important;
    border: solid 1px #4453E1;
    transform: scale(1.1);
}
li{
    margin-right: 35px;
    cursor: pointer;
    font-weight:500;
    font-size: 1em;

}
li:hover{
    color: #0073E6 !important;
}
header{
    border: solid red 1px;

    
}

.NavBar{
    margin: 0 auto;
}

.logo{
    float: left;
    height: 45px;
    width: 100%;
}
.nav{
    width: 100%;
    overflow: hidden;
    color:#fff;
    /* margin-right: 11%; */
}
.menu a{
    display: block;
    color:#fff;
}
.menu a:hover{
    background-color: var(--gray);
}
.nav{
    max-height: 0;
    transition: max-height .5s ease-out;

}
.hamb{
    cursor: pointer;
    float: right;
    padding: 40px 20px;
}

.hamb_line {
    background: #fff;
    display: block;
    height: 2px;
    position: relative;
    width: 24px;
} 
.hamb_line::before,
.hamb_line::after{
    background: #fff;
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    transition: all .2s ease-out;
    width: 100%;
    color:#fff;
}
.hamb_line::before{
    top: 5px;
}
.hamb_line::after{
    top: -5px;
}

.side_menu {
    display: none;
} 

.side_menu:checked ~ nav{
    max-height: 100%;
}
.side_menu:checked ~ .hamb .hamb_line {
    background: transparent;
}
.side_menu:checked ~ .hamb .hamb_line::before {
    transform: rotate(-45deg);
    top:0;
}
.side_menu:checked ~ .hamb .hamb_line::after {
    transform: rotate(45deg);
    top:0;
}

@media (min-width: 768px) {
    .nav{
        max-height: none;
        top: 0;
        position: relative;
        float: right;
        width: fit-content;
        overflow-x: hidden !important;

    }
    .menu li{
        float: left;
    }
    .menu a:hover{
        background-color: transparent;
        color: var(--gray);

    }

    .hamb{
        display: none;
    }
}

@media only screen and (max-width: 869px)  {
  .header{
    background-color: #ffffff;
    position: sticky;
    top: 0;
    width: 100%;
    height: 150px;
  
}
.btnCV{
    margin-left: 0;
}
.NavBar{
    margin-left:0;
}
img{
    float: left;
    height: 100px;
    top: 15% !important;
}

.logo{
    float: left;
    height: 50px;
    width: auto;
}

.btn{
    margin-top: 7px;
    width: 70%;
}

li{
    margin-top:10px;
}
} 
</style>